import {
	moneyFormatter,
	numberFormatter,
} from "../../system/constants/formatters/drh-formatters";
import { NumberFacet } from "../models/facets/number-facet";
import { RangeFacet } from "../models/facets/range-facet";
import { TextFacet } from "../models/facets/text-facet";
import { FacetTypes as FacetTypes } from "./facet-types-enum";

var allFacets = []; // as DrhFacet[];

//Range Facets
export const drhFacetPriceRange: RangeFacet = {
	title: "Price range",
	fieldName: "prices",
	urlParamName: "price:range",
	//formatter: moneyFormatter,
	type: FacetTypes.Range,
	value: [0, 0],
};
allFacets.push(drhFacetPriceRange);

export const drhFacetSize: RangeFacet = {
	title: "Square Footage",
	fieldName: "size",
	urlParamName: "sqft:range",
	//formatter: numberFormatter,
	type: FacetTypes.Range,
	value: [0, 0],
};
allFacets.push(drhFacetSize);

//Number Facets
export const drhFacetBathrooms: NumberFacet = {
	title: "Bathrooms",
	fieldName: "bathrooms",
	type: FacetTypes.Number,
	value: 0,
	urlParamName: "Bathrooms",
};
allFacets.push(drhFacetBathrooms);

export const drhFacetBedrooms: NumberFacet = {
	title: "Bedrooms",
	fieldName: "bedrooms",
	type: FacetTypes.Number,
	value: 0,
	urlParamName: "Bedrooms",
};
allFacets.push(drhFacetBedrooms);

export const drhFacetGarages: NumberFacet = {
	title: "Garages",
	fieldName: "garages",
	type: FacetTypes.Number,
	value: 0,
	urlParamName: "Garages",
};
allFacets.push(drhFacetGarages);

export const drhFacetStories: NumberFacet = {
	title: "Stories",
	fieldName: "stories",
	type: FacetTypes.Number,
	value: 0,
	urlParamName: "Stories",
};
allFacets.push(drhFacetStories);

//Text Facets
export const drhFacetAmenity: TextFacet = {
	title: "Amenities",
	fieldName: "amenities",
	type: FacetTypes.Text,
	value: [],
	urlParamName: "Amenities",
};
allFacets.push(drhFacetAmenity);

export const drhFacetPropertyType: TextFacet = {
	title: "Property type",
	fieldName: "propertyType",
	type: FacetTypes.Text,
	value: [],
	urlParamName: "PropertyType",
};
allFacets.push(drhFacetPropertyType);

export const drhFacetHomeSeries: TextFacet = {
	title: "Home series",
	fieldName: "homeSeries",
	type: FacetTypes.Text,
	value: [],
	urlParamName: "Brand",
};
allFacets.push(drhFacetHomeSeries);

export default allFacets;
